<script lang="ts">
    import Login from "./Login.svelte";
    import Register from "./Register.svelte";
    import WelcomeRegister from "./WelcomeRegister.svelte";
    let register = true;
    let showWelcome = false;
    // const src =
    //     "https://images.unsplash.com/photo-1606559497615-e4787c3c75a1?q=80&w=5000&h=5000&auto=png&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
</script>

<section
    class="fixed inset-0 flex items-center justify-center bg-cover bg-center bg-no-repeat"
    style={"background-image: url(/Background.jpeg);"}
>
    <div class="container p-4 bg-white rounded-lg shadow-lg max-w-md">
        {#if register}
            {#if showWelcome}
                <WelcomeRegister />
            {:else}
                <Register
                    on:click={() => {
                        register = false;
                    }}
                    on:confirm={() => {
                        showWelcome = true;
                    }}
                />
            {/if}
        {:else}
            <Login
                on:click={() => {
                    register = true;
                }}
                on:loggedin
            />
        {/if}
    </div>
</section>
